import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("bathroom/index"),
  
  store: (userData) => clientAuth.post('bathroom/store', { json: userData }),
  

  show:(id)=>clientAuth.get('bathroom/show/'+id),

  update:(id,userData)=>clientAuth.post('bathroom/update/'+id,{json:userData}),

  destroy:(id)=>clientAuth.delete(`bathroom/destroy/${id}`),
};